export function PageSpinner({ inline = false }: { inline?: boolean }) {
  return (
    <div
      className={
        inline
          ? 'flex w-full items-center justify-center py-12'
          : 'flex min-h-[60vh] w-full items-center justify-center'
      }
    >
      <span className="loading loading-spinner loading-xl text-primary" />
    </div>
  )
}
